import { GoldView } from './gold';

export function GoldScreen() {
  return (
    <div className="h-full w-full overflow-y-auto p-4 md:p-6">
      <GoldView />
    </div>
  );
}
